import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpegToJpgConfig } from '@/data/landingConfig/landingJpegToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpegToJpg } from './schemaObject';

interface Props {}
const JpegToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpegToJpg} />
			<LandingTemplate
				data={landingJpegToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpegToJpgConverter;
